module.exports = __webpack_public_path__ + "fbf6dbeeabbadc8b9f02876c86100df6.svg";